<div class="item toggle">
  <div class="sample" [ngClass]="{'no-icon': actionTemplate === undefined}">
    <span class="title h6" title="{{ obj[titleProperty] }}" *ngIf="titleProperty && !titleTemplate">
      {{ obj[titleProperty] }}
    </span>

    <!-- Title template -->
    <ng-container *ngTemplateOutlet="titleTemplate; context: {row: obj}"></ng-container>

    <!-- Subtitle template -->
    <span class="subtitle" *ngIf="subtitleTemplate">
      <ng-container *ngTemplateOutlet="subtitleTemplate; context: {row: obj}"></ng-container>
    </span>
  </div>

  <div *ngIf="actionTemplate" class="actions">
    <ng-container *ngTemplateOutlet="actionTemplate; context: {row: obj}"></ng-container>
  </div>

  <div [ngClass]="{'open': open}" class="show" (click)="toggleDetails()">
    <i class="fa fa-angle-right"></i>
  </div>
</div>

<div *ngIf="open" class="details">
  <div class="details-content columns col-gapless">
    <div class="column col-12 col-xs-12 data-list data-list-block">
      <dl *ngFor="let prop of properties">
        <ng-container *ngIf="getDisplayedValue(obj, prop.key) !== undefined">
          <dt>
            {{ prop.label | translate }}
          </dt>
          <dd *ngIf="!prop.customTemplate">
            {{ getDisplayedValue(obj, prop.key) }}
          </dd>
        </ng-container>

        <!-- Custom template -->
        <dd *ngIf="prop.customTemplate">
          <ng-container *ngTemplateOutlet="prop.customTemplate; context: {row : obj}"></ng-container>
        </dd>
      </dl>
    </div>
  </div>
</div>